import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-daily-savings',
  templateUrl: './edit-daily-savings.component.html',
  styleUrls: ['./edit-daily-savings.component.sass']
})
export class EditDailySavingsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
